<template>
  <div
    class=" tw-py-[14px] tw-px-[20px] tw-rounded-lg tw-flex tw-gap-2 tw-items-center"
    :class="['C', 'D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant) ? 'tw-bg-[#F3F3F3]' : 'tw-bg-pastel-mint'"
  >
    <IconCardCheck
      v-if="!isOnboardingRedesign"
      class="tw-text-black tw-shrink-0"
    />

    <div>
      <h4
        :class="{
          'tw-text-[12px]': !isOnboardingRedesign,
          'tw-text-lg md:tw-text-2xl tw-flex tw-items-center': isOnboardingRedesign,
        }"
      >
        <IconCardCheck
          v-if="isOnboardingRedesign"
          class="tw-mr-2"
        />
        HSA/FSA{{ ['D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)? '&nbsp;Funds' : '-eligible' }}
      </h4>
      <p
        :class="{
          'tw-text-[11px]': !isOnboardingRedesign,
          'tw-text-sm tw-leading-5 md:tw-text-lg tw-mt-2': isOnboardingRedesign,
        }"
      >
        {{ ['E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant) ? 'Use your card now, or download reimbursement documents from the Patient Portal.' : 'Enter the card details as you would a normal credit card. Any forms you require can be found in the portal after' }}
      </p>
    </div>
  </div>
</template>

<script>
/**
import OnboardingHsaFsaBadge from '@/components/onboarding/OnboardingHsaFsaBadge'
 */

//  components
import IconCardCheck from '@/components/icon/IconCardCheck';

// eslint-disable-next-line no-unused-vars
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  components: {
    IconCardCheck,
  },
  computed: {
    ...mapState('cro', ['isHsaFsaBadgeTracked']),
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
  },

  mounted () {
    if (this.isHsaFsaBadgeTracked) {
      return
    }

    this.$store.commit('cro/SET_STATE', {
      isHsaFsaBadgeTracked: true,
    });
  },
}
</script>

<style lang="scss" scoped>
h4, p {
  margin: 0;
  padding: 0;
}
</style>